import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import dayjs from 'dayjs'
import type { Plugin } from 'vue'

const DayJsPlugin: Plugin = {
  install(app, options) {
    dayjs.extend(isSameOrAfter)
    dayjs.extend(isSameOrBefore)
    dayjs.extend(customParseFormat)

    app.config.globalProperties.$date = dayjs
  }
}

export default DayJsPlugin
